/**
 * Trigger a browser download of an in-memory SQL snapshot. Used by the admin
 * export actions (BioMatch library, Global Products) as the fallback when the
 * server can't email the snapshot (SendGrid unconfigured).
 */
export function downloadSqlFile(filename: string, sql: string) {
    const blob = new Blob([sql], {type: 'application/sql'});
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
}
